module.exports = __webpack_public_path__ + "static/img/chat.ead10fbb.png";